// components/MultiSelect.tsx
import React from "react";
import Select from "react-select";

type Option = {
    label: string;
    value: string;
};

type MultiSelectProps = {
    options: Option[];
    defaultSelected?: Option[];
    onChange: (selected: Option[]) => void;
};

const customStyles = {
    control: (provided: any) => ({
        ...provided,
        borderRadius: "0.5rem",
        borderColor: "#d1d5db", // Tailwind gray-300
        minHeight: "42px",
        boxShadow: "none",
        "&:hover": {
            borderColor: "#6366f1", // indigo-500
        },
    }),
    multiValue: (base: any) => ({
        ...base,
        backgroundColor: "#e0e7ff", // indigo-100
    }),
    multiValueLabel: (base: any) => ({
        ...base,
        color: "#3730a3", // indigo-700
    }),
    multiValueRemove: (base: any) => ({
        ...base,
        color: "#7c3aed",
        ':hover': {
            backgroundColor: '#c7d2fe',
            color: '#312e81',
        },
    }),
};

const MultiSelect: React.FC<MultiSelectProps> = ({ options, defaultSelected = [], onChange }) => {
    return (
        <div>
            <Select
                isMulti
                options={options}
                defaultValue={defaultSelected}
                onChange={(selected) => onChange(selected as Option[])}
                styles={customStyles}
                placeholder="Chọn mục..."
                closeMenuOnSelect={false}
            />
        </div>
    );
};

export default MultiSelect;
